import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    content: null,
    time: null
}
model.dataSearch = {
    dien_thoai: null,
    type: null
}
model.tableRules = {
    data: [],
    lengthMenu: [25, 50, 75, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 25,
    skip: 0,
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            sdt: "",
            type: ""
        },
        valid: {
            sdt: [ValidService.required, ValidService.checkNumber, ValidService.checkPhone],
            type: []
        },
        operator: {
            sdt: "", //:regex:, $vn_text=Viêt nam
            type: ""
        }
    }
};
  
export default model;